import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const PostGenerateWordCloud = (
  exclude_words: string,
  id_ean: string,
  save: boolean,
  adjectiveWeight = 10,
) => {
  return apiInstance.post(ApiPathConfig.GENERATE_WORD_CLOUD(id_ean), {
    exclude_words,
    save,
    coef: adjectiveWeight,
  })
}

export default PostGenerateWordCloud
